// // import React, { useEffect, useState, useMemo } from "react";
// // import { useNavigate, useLocation } from "react-router-dom";
// // import "../style/card.css";
// // import CloseIcon from "@mui/icons-material/Close";

// // const getYouTubeId = (url) => {
// //   if (!url || typeof url !== "string") return null;
// //   try {
// //     const u = new URL(url);
// //     if (u.hostname.includes("youtu.be")) {
// //       return u.pathname.slice(1) || null;
// //     }
// //     if (u.hostname.includes("youtube.com")) {
// //       const v = u.searchParams.get("v");
// //       if (v) return v;
// //     }
// //     const m = url.match(/(?:v=|\/embed\/|\.be\/)([A-Za-z0-9_-]{6,11})/);
// //     return m ? m[1] : null;
// //   } catch {
// //     return null;
// //   }
// // };

// // const thumbnailFor = (url) => {
// //   const id = getYouTubeId(url);
// //   if (!id) return "/placeholder-video.jpg";
// //   return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
// // };

// // const AIandDigital = () => {
// //   const location = useLocation();
// //   const navigate = useNavigate();
// //   const selectedCategory = location.state?.category || null;

// //   const [videos, setVideos] = useState([]);
// //   const [loading, setLoading] = useState(true);

// //   // 🔥 FETCH FROM API
// //   useEffect(() => {
// //     const fetchVideos = async () => {
// //       try {
// //         const response = await fetch("http://localhost:8000/youtube-links/");
// //         const data = await response.json();

// //         // Map API response to match your UI structure
// //         const formatted = data.map((item) => ({
// //           id: item.id,
// //           title: item.title, // You don't have title in API, so using category as title
// //           link: item.youtube_url,
// //           category: item.category,
// //           year: item.year,
// //           status: item.status,
// //         }));

// //         setVideos(formatted);
// //       } catch (error) {
// //         console.error("Error fetching videos:", error);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };

// //     fetchVideos();
// //   }, []);

// //   // FILTER BY CATEGORY
// //   const filteredList = useMemo(() => {
// //     if (!selectedCategory) return videos;
// //     return videos.filter(
// //       (item) => item.category === selectedCategory
// //     );
// //   }, [videos, selectedCategory]);

// //   const openVideo = (item) => {
// //     if (!item?.link) {
// //       alert("No video link available.");
// //       return;
// //     }
// //     window.open(item.link, "_blank", "noopener,noreferrer");
// //   };

// //   if (loading) {
// //     return <h3>Loading videos...</h3>;
// //   }

// //   return (
// //     <>
// //     <main className="main-content">
// //       {/* Back Button */}
// //       <div style={{ marginBottom: 20 }}>
// //         <br/>

// //         <button className="clear-filters-btn" onClick={() => navigate("/library")}>
// //           ← Back 
// //         </button>
// //       </div>

// //       {selectedCategory && (
// //         <h2 style={{ marginBottom: 20 }}>{selectedCategory}</h2>
// //       )}

// //       <div className="content-grid">
// //         {filteredList.map((item) => {
// //           const thumb = thumbnailFor(item.link);

// //           return (
// //             <div className="content-card-new" key={item.id}>
// //               <div
// //                 className="card-thumbnail-new"
// //                 onClick={() => openVideo(item)}
// //               >
// //                 <img
// //                   src={thumb}
// //                   alt={item.title}
// //                   className="video-thumbnail"
// //                 />
// //                 <div className="play-button-new">▶</div>
// //               </div>

// //               <div className="card-content-new">
// //                 <h3>{item.title}</h3>
// //                 <p>{item.year}</p>
// //                 {/* <p>Status: {item.status}</p> */}
// //               </div>

// //               <div className="card-actions-new">
// //                 <button className="watch-btn-new" onClick={() => openVideo(item)}>
// //                   Watch
// //                 </button>
// //               </div>
// //             </div>
// //           );
// //         })}

// //         {filteredList.length === 0 && (
// //           <div style={{ padding: 20 }}>
// //             <h3>No videos found in this category</h3>
// //           </div>
// //         )}
// //       </div>
// //       </main>
// //     </>
// //   );
// // };

// // export default AIandDigital;


// import React, { useEffect, useState, useMemo } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import "../style/card.css";
// import CloseIcon from "@mui/icons-material/Close";
// import { AbstractAPI } from "../api";

// const getYouTubeId = (url) => {
//   if (!url || typeof url !== "string") return null;
//   try {
//     const u = new URL(url);
//     if (u.hostname.includes("youtu.be")) {
//       return u.pathname.slice(1) || null;
//     }
//     if (u.hostname.includes("youtube.com")) {
//       const v = u.searchParams.get("v");
//       if (v) return v;
//     }
//     const m = url.match(/(?:v=|\/embed\/|\.be\/)([A-Za-z0-9_-]{6,11})/);
//     return m ? m[1] : null;
//   } catch {
//     return null;
//   }
// };

// const thumbnailFor = (url) => {
//   const id = getYouTubeId(url);
//   if (!id) return "/placeholder-video.jpg";
//   return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
// };

// // 🔥 Helper: normalize strings
// const normalize = (str) => (str ? str.toLowerCase().trim() : "");

// const AIandDigital = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const selectedCategory = location.state?.category || null;

//   const [videos, setVideos] = useState([]);
//   const [loading, setLoading] = useState(true);

// useEffect(() => {
//   const fetchVideos = async () => {
//     try {
//       const data = await AbstractAPI.getAllYoutubeLinks();

//       const activeItems = data.filter(
//         (item) => String(item.status).toLowerCase() === "active"
//       );

//       const formatted = activeItems.map((item) => ({
//         id: item.id,
//         title: item.title || item.category,
//         link: item.youtube_url,
//         category: item.category,
//         year: item.year,
//         status: item.status,
//         speakers: item.speakers || []
//       }));

//       setVideos(formatted);
//     } catch (error) {
//       console.error("Error fetching videos:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchVideos();
// }, []);


//   const filteredList = useMemo(() => {
//     if (!selectedCategory) return videos;

//     const normalizedSelected = normalize(selectedCategory);

//     return videos.filter(
//       (item) => normalize(item.category) === normalizedSelected
//     );
//   }, [videos, selectedCategory]);

//   const openVideo = (item) => {
//     if (!item?.link) {
//       alert("No video link available.");
//       return;
//     }
//     window.open(item.link, "_blank", "noopener,noreferrer");
//   };

//   if (loading) {
//     return <h3>Loading videos...</h3>;
//   }

//   return (
//     <main className="main-content">
//       <div style={{ marginBottom: 20 }}>
//         <br />
//         <button
//           className="clear-filters-btn"
//           onClick={() => navigate("/library")}
//         >
//           ← Back
//         </button>
//       </div>

//       {selectedCategory && (
//         <h2 style={{ marginBottom: 20 }}>{selectedCategory}</h2>
//       )}

//       <div className="content-grid">
//         {filteredList.map((item) => {
//           const thumb = thumbnailFor(item.link);

//           return (
//             <div className="content-card-new" key={item.id}>
//               <div
//                 className="card-thumbnail-new"
//                 onClick={() => openVideo(item)}
//               >
//                 <img src={thumb} alt={item.title} className="video-thumbnail" />
//                 <div className="play-button-new">▶</div>
//               </div>

//               <div className="card-content-new">
//                 <h3>{item.title}</h3>
//                 {item.speakers && item.speakers.length > 0 && (
//                   <p className="speaker-list">
//                     <strong>Speakers: </strong>
//                     {item.speakers.map(s => `${s.title || ""} ${s.first_name || ""} ${s.last_name || ""}`.trim()).join(", ")}
//                   </p>
//                 )}
//                 <p>{item.year}</p>
//               </div>

//               <div className="card-actions-new">
//                 <button
//                   className="watch-btn-new"
//                   onClick={() => openVideo(item)}
//                 >
//                   Watch
//                 </button>
//               </div>
//             </div>
//           );
//         })}

//         {filteredList.length === 0 && (
//           <div style={{ padding: 20 }}>
//             <h3>No videos found in this category</h3>
//           </div>
//         )}
//       </div>
//     </main>
//   );
// };

// export default AIandDigital;





import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "../style/card.css";
import { AbstractAPI } from "../api";

const getYouTubeId = (url) => {
  if (!url || typeof url !== "string") return null;
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) return u.pathname.slice(1) || null;
    if (u.hostname.includes("youtube.com")) {
      const v = u.searchParams.get("v");
      if (v) return v;
    }
    const m = url.match(/(?:v=|\/embed\/|\.be\/)([A-Za-z0-9_-]{6,11})/);
    return m ? m[1] : null;
  } catch {
    return null;
  }
};

const thumbnailFor = (url) => {
  const id = getYouTubeId(url);
  if (!id) return "/placeholder-video.jpg";
  return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
};
const highlightText = (text = "", query = "") => {
  if (!query) return text;

  const escapedQuery = query.replace(
    /[.*+?^${}()|[\]\\]/g,
    "\\$&"
  );

  const regex = new RegExp(`(${escapedQuery})`, "gi");

  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === query.toLowerCase() ? (
      <mark
        key={index}
        style={{
          backgroundColor: "#ffeb3b",
          padding: "0 2px",
          borderRadius: "2px",
        }}
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
};
const normalize = (str) => (str ? str.toLowerCase().trim() : "");

const normalizeStatus = (status) => {
  if (!status) return "";
  const s = String(status).toUpperCase().trim();
  if (s === "A" || s === "ACTIVE") return "Active";
  return status;
};

const buildSpeakerName = (s) =>
  [s.title, s.first_name, s.last_name]
    .filter((p) => p && p.trim())
    .join(" ")
    .trim();

const AIandDigital = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const selectedCategory = location.state?.category || null;
  const selectedSubcategory = location.state?.subcategory || null;
  // ✅ allowedTitles = paper titles from MainContent's subdata for this subcategory
  const allowedTitles = location.state?.allowedTitles || []; // string[]
  const initialQuery = location.state?.query || "";

  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState(initialQuery);

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const data = await AbstractAPI.getAllYoutubeLinks();



        const activeItems = data.filter(
          (item) =>
            String(item.status).toUpperCase() === "A" ||
            String(item.status).toLowerCase() === "active"
        );


        const formatted = activeItems.map((item) => {
          const speakersList = Array.isArray(item.speakers)
            ? item.speakers.map(buildSpeakerName).filter(Boolean)
            : [];

          return {
            id: item.id,
            title: item.title || item.category,
            link: item.youtube_url,
            category: item.category,
            year: item.year,
            status: normalizeStatus(item.status),
            speakers: speakersList,
            speakersFlat: speakersList.join(" "),
          };
        });

        setVideos(formatted);
      } catch (error) {
        console.error("Error fetching videos:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  const filteredList = useMemo(() => {
    let result = videos;

    // 1. Filter by category (exact)
    if (selectedCategory) {
      const cat = normalize(selectedCategory);
      result = result.filter((v) => normalize(v.category) === cat);
    }

    // 2. Filter by subcategory using allowedTitles passed from MainContent
    //    allowedTitles = paper titles inside that subcategory's subdata
    //    Match video title against those paper titles (exact normalized match)
if (selectedSubcategory && allowedTitles.length > 0) {
  const normalizedAllowed = allowedTitles.map(normalize);

  result = result.filter((v) => {
    const videoTitle = normalize(v.title);

    return normalizedAllowed.some((paperTitle) =>
      videoTitle.includes(paperTitle) ||
      paperTitle.includes(videoTitle)
    );
  });
}

    // 3. Search bar — title + all speaker names
    const q = normalize(searchQuery);
    if (q) {
      result = result.filter((v) => {
        const hay = normalize(
          v.title + " " + v.speakersFlat + " " + v.category
        );
        return hay.includes(q);
      });
    }

    return result;
  }, [videos, selectedCategory, selectedSubcategory, allowedTitles, searchQuery]);

  const openVideo = (item) => {
    if (!item?.link) {
      alert("No video link available.");
      return;
    }
    window.open(item.link, "_blank", "noopener,noreferrer");
  };

  if (loading) return <h3>Loading videos...</h3>;

  return (
    <main className="main-content">
      <div style={{ marginBottom: 20 }}>
        <br />
        <button className="clear-filters-btn" onClick={() => navigate("/library")}>
          ← Back
        </button>
      </div>

      {selectedCategory && <h2 style={{ marginBottom: 8 }}>{selectedCategory}</h2>}
      {selectedSubcategory && (
        <h4 style={{ marginBottom: 16, color: "#666" }}>{selectedSubcategory}</h4>
      )}

      {/* Search bar */}
      {/* <div style={{ marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
        <input
          type="text"
          placeholder="Search by title or speaker name..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: "100%",
            maxWidth: 420,
            padding: "8px 14px",
            borderRadius: 6,
            border: "1px solid #ccc",
            fontSize: 14,
          }}
        />
        {searchQuery && (
          <button
            onClick={() => setSearchQuery("")}
            style={{
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: 14,
              color: "#888",
            }}
          >
            ✕ Clear
          </button>
        )}
      </div> */}

      <div className="content-grid">
        {filteredList.map((item) => {
          const thumb = thumbnailFor(item.link);

          return (
            <div className="content-card-new" key={item.id}>
              <div className="card-thumbnail-new" onClick={() => openVideo(item)}>
                <img src={thumb} alt={item.title} className="video-thumbnail" />
                <div className="play-button-new">▶</div>
              </div>

              <div className="card-content-new">
                <h3>{highlightText(item.title, searchQuery)}</h3>




                {/* {item.category && (
                  <p className="card-category">{item.category}</p>
                )} */}
                <h4>Speakers:</h4>
                {item.speakers.length > 0 && (
                  <p className="card-speaker">
                    {highlightText(item.speakers.join(", "), searchQuery)}
                  </p>
                )}
                <br />



              </div>

              <div className="card-actions-new">

                {item.year && <span className="card-year">IEW {item.year}</span>}
                {/* {item.status && <span className="card-status">{item.status}</span>} */}

                <button className="watch-btn-new" onClick={() => openVideo(item)}>
                  Watch
                </button>
              </div>
            </div>
          );
        })}

        {filteredList.length === 0 && (
          <div style={{ padding: 20 }}>
            <h3>No videos found</h3>
          </div>
        )}
      </div>
    </main>
  );
};

export default AIandDigital;
